import { useFetch } from '../../use-fetch/use-fetch';
import { AnyObject, ApiResponse, ResponseModel } from '../../../common/interfaces';
import { useQuery } from 'react-query';
import { ReactQueryKeys } from '../../../common/enums';
import { RequestStatuses } from '../../../constants';
import { transformCrmResponse } from '../../../utils/transform-crm-response';
import { ContactsByCriteriaPayload } from './use-contacts-by-criteria.types';
import { userRequestConfig } from '../../../request-config/user/user.request-config';

const modifyResponse = ({ data }: ApiResponse<AnyObject[]>) => {
  if (data.level === RequestStatuses.Success) {
    return data.data.map(item => transformCrmResponse(item));
  }

  return [];
};

const useContactsByCriteria = (payload: ContactsByCriteriaPayload) => {
  const { fetch } = useFetch<ResponseModel>({
    isShowLoading: false,
    isShowErrorSnackbar: false,
    ...userRequestConfig.getContactsByCriteria(payload)
  });

  const { data } = useQuery<ApiResponse<AnyObject[]>, unknown, AnyObject[]>(
    [ReactQueryKeys.GetContactsByCriteria, payload],
    fetch,
    {
      select: modifyResponse,
      enabled: !!payload
    }
  );

  return {
    data
  };
};

export default useContactsByCriteria;
